import React, { useState } from "react";

import "react-toastify/dist/ReactToastify.css";
//
const userStateContext = React.createContext();
const userDispatchContext = React.createContext();

const UserProvider = ({ children }) => {
  const [isUserAuthenticated, setIsUserAuthenticated] = useState(
    !!localStorage.getItem("token")
  );

  return (
    <userStateContext.Provider value={{ isUserAuthenticated }}>
      <userDispatchContext.Provider value={{ setIsUserAuthenticated }}>
        {children}
      </userDispatchContext.Provider>
    </userStateContext.Provider>
  );
};

const useUserState = () => {
  const context = React.useContext(userStateContext);

  return context;
};
const useUserDispatch = () => {
  const context = React.useContext(userDispatchContext);
  return context;
};

export { UserProvider, useUserState, useUserDispatch };
